/**
 * The banner while this browser tries a design system on (design systems round 2): which one, what
 * of it is worn (round 4: the tokens, the art, more stylesheets and the fonts), what could not be
 * fetched, that nobody else sees it, and a way to stop without reloading. Nothing shows otherwise.
 */

import { Palette } from '@gravity-ui/icons';
import { useSyncExternalStore } from 'react';

import { subscribeConsoleDesignSystem, tryingOn, tryOnDesignSystem } from '../orgDesignSystem.ts';
import { Button } from './ui.tsx';

export function DesignSystemTryOn() {
  const t = useSyncExternalStore(subscribeConsoleDesignSystem, tryingOn);
  if (!t) return null;
  return (
    <div role="status" className="card-art flex shrink-0 items-center gap-3 px-4 py-2 text-sm" data-tone="violet">
      <span className="card-art__icon !size-7" aria-hidden="true">
        <Palette className="size-4" />
      </span>
      <span className="min-w-0 flex-1">
        Trying <span className="font-medium">{t.name}</span> <span className="tabular-nums">{t.version}</span>: {t.wearing}
        {t.missing.length ? <span className="text-muted"> ({t.missing.length === 1 ? `${t.missing[0]} could not be fetched` : `${t.missing.length} files could not be fetched`})</span> : null}. Nobody
        else sees this.
      </span>
      <Button size="sm" variant="ghost" onPress={() => tryOnDesignSystem(undefined)}>
        Stop
      </Button>
    </div>
  );
}
